export default {
  menu: null,
  error: false,
  errorMessage: "",
  successMessage: "",
  success: false,
};
